function consultationReqWA(payload) {
    var WA = `Estimado/a ${payload.patient_name}:\nA continuación en el *siguiente link* podrá agendar una nueva consulta.`
    return WA
}

export {consultationReqWA}